import { AuthenticatedHttpClient } from "@/lib/axios";
import { PaginatedResponse } from "@/types/common";
import { Member } from "@/types/member.types";
import { OnboardingStatus } from "@/types/organisation.types";
import { AxiosResponse } from "axios";

export class MemberService {
  private http: AuthenticatedHttpClient;

  constructor(httpClient: AuthenticatedHttpClient) {
    this.http = httpClient;
  }

  //-------------------- Retrieval Methods --------------------

  async getMember(id: string): Promise<AxiosResponse<Member>> {
    const response = await this.http.get<Member>(`/member/${id}`);
    return { data: response } as unknown as AxiosResponse<Member>;
  }

  async getAllMembers(params: { page: number; limit: number }) {
    return (await this.http.get("/member", {
      params,
    })) as unknown as PaginatedResponse<Member>;
  }

  //-------------------- Modification Methods --------------------

  async updateMember(
    id: string,
    member: Partial<Member>
  ): Promise<AxiosResponse<Member>> {
    return this.http.patch<Member>(`/member/${id}`, member);
  }

  //-------------------- Deletion Methods --------------------

  async deleteMember(memberId: string): Promise<AxiosResponse<void>> {
    return this.http.delete<void>(`/member/${memberId}`);
  }

  async bulkDeleteMembers(memberIds: string[]): Promise<AxiosResponse<void>> {
    return this.http.post<void>("/member/bulk-delete", { memberIds });
  }

  //-------------------- Suspension Methods --------------------

  async suspendMember(memberId: string, suspended: boolean): Promise<Member> {
    return this.http.post(
      `/member/${memberId}/suspension/${suspended}`
    ) as unknown as Member;
  }

  async bulkSuspendMembers(
    ids: string[],
    suspended: boolean
  ): Promise<AxiosResponse<void>> {
    return this.http.post(`/member/bulk-suspend`, { ids, suspended });
  }

  //-------------------- Onboarding Methods --------------------

  async onboardMember(): Promise<OnboardingStatus> {
    const response = await this.http.post<OnboardingStatus>(
      `/onboarding/membership`
    );
    return response as unknown as OnboardingStatus;
  }
}
